<template>
  <div class="col-sm-12 product-item-details-wrapper">
    <div class="col-sm-4">
      <div class="product-image-item-wrapper">
          <div class="single-products">
              <div class="text-center">
                <img v-if="smallimages === true" class="img-responsive" :src="'/static/images/product/' + product.image.replace('.jpg','_small.jpg')" :alt="product.description" @error="replaceNonFoundImage($event)"/>
                <img v-else class="img-responsive" :src="'/static/images/product/' + product.image" :alt="product.description" @error="replaceNonFoundImage($event)"/>
              </div>
          </div>
      </div>
    </div>
    <div class="col-sm-8">
      <div class="productinfo">
        <div class="product-details-and-price">
          <h2>{{ product.description }}</h2>
          <p>from &pound;{{product.lowestCost.toFixed(2)}}</p>
        </div>
        <div class="button-links">
            <router-link :to="'/shop/' + groupSlug + '/' + categorySlug + '/'+ product.slug" class="btn btn-default add-to-cart">Buy <span class="basket">{{product.description}}</span> now</router-link>
            <router-link :to="'/shop/' + groupSlug + '/' + categorySlug + '/'+ product.slug" class="btn btn-default add-to-cart">More Details <span class="basket"> on {{product.description}}</span></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-item',
  props: ['product', 'smallimages', 'groupSlug', 'categorySlug'],
  methods: {
    /* eslint no-param-reassign: "error" */
    replaceNonFoundImage(event) {
      if (this.$props.smallimages === true) {
        event.target.src = '/static/images/product/notfoundsmall.jpg';
      } else {
        event.target.src = '/static/images/product/notfound.jpg';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/products/ProductItemDetails.vue